import { render, staticRenderFns } from "./AgeAndGender.vue?vue&type=template&id=d4e9c620&scoped=true"
import script from "./AgeAndGender.vue?vue&type=script&lang=js"
export * from "./AgeAndGender.vue?vue&type=script&lang=js"
import style0 from "./AgeAndGender.vue?vue&type=style&index=0&id=d4e9c620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e9c620",
  null
  
)

export default component.exports